import { createStyles, Menu } from "@mantine/core";
import { tokens } from "@blurb/codex-react";
import { IconV3 } from "@rpi/openapi-core";
import React from "react";

const useMenuStyle = createStyles({
  menuButton: {
    textDecoration: "none",
    padding: 0,
    border: "none",
    background: "transparent",
    cursor: "pointer",
  },
  dropdown: {
    borderRadius: tokens.radius.lg,
    background: tokens.color.semantic.bg.surfaceRaised,
    padding: tokens.spacing[2],
    boxShadow: "0 4px 12px 1px rgba(0, 0, 0, 0.10)",
  },
  item: {
    fontSize: tokens.font.size.base,
    gap: tokens.spacing[2],
    padding: tokens.spacing[2],
  },
});

export type RpaTableMenuProps = {
  children: React.ReactNode;
};

export const RpaTableMenu: React.FC<RpaTableMenuProps> = ({ children }) => {
  const { classes } = useMenuStyle();
  return (
    <Menu width={240} position="bottom-start" offset={0} withinPortal classNames={classes}>
      <Menu.Target>
        <button type="button" aria-label="Menu Actions" className={classes.menuButton}>
          <IconV3 icon="more_vert" size={20} color={tokens.color.semantic.icon.subtle} />
        </button>
      </Menu.Target>
      <Menu.Dropdown>{children}</Menu.Dropdown>
    </Menu>
  );
};
